// extracted by mini-css-extract-plugin
export default {"Navigation":"WorkspaceSection_Navigation__5TxLc","Main":"WorkspaceSection_Main__JI5Un"};